import * as R from 'remeda'
import { optionIsInOrderConfig } from 'utils/optionIsInOrderConfig'
import { optionIsInCart } from 'utils/optionIsInCart'

export function getOrderedOptionsCheckout(_currentVariant, orderConfig, cartItems) {
  const accum = []
  for (const step of Object.values(_currentVariant.steps)) {
    for (const setting of R.sortBy(Object.values(step.settings), (s) => s.ordering)) {
      for (const option of R.sortBy(Object.values(setting.options), (s) => s.ordering)) {
        if (optionIsInOrderConfig(option, orderConfig) || optionIsInCart(option, cartItems)) {
          accum.push(option)
        }
      }
    }
  }

  for (const cartItem of cartItems) {
    const element = accum.find((o) => String(o.accessory_product) === String(cartItem.id))
    if (element === undefined) {
      accum.push({
        accessory_product: cartItem.id,
        accessory_product_obj: cartItem,
        can_be_removed: true,
        id: cartItem.id,
        price: String(cartItem.price.raw),
        price_leasing: String(cartItem.price_leasing.raw),
        security_deposit_leasing: String(cartItem.security_deposit_leasing?.raw ?? 0),
        title: cartItem.title,
        type: 'accessory-product',
        use_leasing_price: cartItem.use_leasing_price
      })
    }
  }

  return accum
}
